"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _SearcherDateCarousel = _interopRequireDefault(require("../SearcherDateCarousel"));
var _ChevronCompactRight = _interopRequireDefault(require("../../icons-react/rebrand/ChevronCompactRight"));
var _excluded = ["children", "showSkeleton"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BADGE_WIDTH = 126;
var itemStyle = {
  width: BADGE_WIDTH
};
var StyledArrow = (0, _styledComponents["default"])(_ChevronCompactRight["default"]).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledArrow",
  componentId: "sc-11zwj95-0"
})(["position:absolute;cursor:pointer;width:40px;height:100px;padding:17px 0;top:-10px;z-index:2;background-image:linear-gradient(to right,rgba(255,255,255,0) 0%,rgb(255,255,255) 80%);border-radius:0 var(--border-radius) var(--border-radius) 0;path{fill:var(--grey2);}"]);
var StyledPrevArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledPrevArrow",
  componentId: "sc-11zwj95-1"
})(["transform:rotate(180deg);left:var(--border-radius);left:0;"]);
var StyledNextArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledNextArrow",
  componentId: "sc-11zwj95-2"
})(["transform:none;right:var(--border-radius);right:0;"]);
var nextCls = 'swiper-button-custom-next';
var prevCls = 'swiper-button-custom-prev';
var StyledSearcherDateCarousel = (0, _styledComponents["default"])(_SearcherDateCarousel["default"]).withConfig({
  displayName: "SearcherDateCarouselDesktop__StyledSearcherDateCarousel",
  componentId: "sc-11zwj95-3"
})(["", ""], function (_ref) {
  var noSwiping = _ref.noSwiping;
  return noSwiping && (0, _styledComponents.css)([".", ",.", "{visibility:hidden;}"], nextCls, prevCls);
});
var config = {
  navigation: {
    nextEl: ".".concat(nextCls),
    prevEl: ".".concat(prevCls)
  },
  renderPrevButton: function renderPrevButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledNextArrow, {
      className: nextCls
    });
  },
  renderNextButton: function renderNextButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledPrevArrow, {
      className: prevCls
    });
  }
};
var SearcherDateCarouselDesktop = function SearcherDateCarouselDesktop(_ref2) {
  var children = _ref2.children,
    showSkeleton = _ref2.showSkeleton,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherDateCarousel, (0, _extends2["default"])({}, config, {
    noSwiping: showSkeleton
  }, props), _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      dataIndex: index,
      style: itemStyle,
      showBackground: true,
      skeleton: showSkeleton
    });
  }));
};
SearcherDateCarouselDesktop.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  showSkeleton: _propTypes["default"].bool
};
SearcherDateCarouselDesktop.defaultProps = {
  className: '',
  showSkeleton: false
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(SearcherDateCarouselDesktop);